/**
 *
 * Asynchronously loads the component for QuizDetailsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const QuizDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.QuizDetailsPage,
);
